<template>
  <div v-if="showDiscount">
    <div class="w-full max-w-xl mx-auto px-5 py-3 flex justify-between">
      <div>
        <p class="font-semibold text-18">Descuento</p>
      </div>
      <div class="text-right">
        <p class="text-blue text-18 font-semibold">
          -${{ discountAmount }}
        </p>
      </div>
    </div>
    <div class="w-full max-w-xl bg-gray-200 p-5 mt-2 mb-6 rounded-2xl text-center mx-auto flex justify-between">
      <div>
        <p class="font-semibold text-18">Costo Mensual Promoción</p>
      </div>
      <div class="text-right">
        <p class="text-18 font-semibold">
          ${{ promotionalPrice }}
        </p>
      </div>
    </div>

    <div class="text-blue text-center">
      <p>La mensualidad del paquete {{ product.nombre }} con promoción por 12 meses será de ${{ promotionalPrice }}.</p>
      <p>Posterior será a precio full de ${{ product.precio }} al mes (un equipo instalado).</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  product: {
    type: Object,
    default: null
  },
  paymentMethod: {
    type: String,
    default: ''
  },
  flagHD: {
    type: Boolean,
    default: false
  }
});

const showDiscount = computed(() => {
  return (
    (props.paymentMethod === 'card' || props.paymentMethod === 'telmex') &&
    props.flagHD &&
    parseInt(props.product?.desc_dom || 0) < 0
  );
});

const discountAmount = computed(() => {
  return parseFloat((props.product?.desc_dom || 0) * -1).toFixed(2);
});

const promotionalPrice = computed(() => {
  const basePrice = parseFloat(props.product?.precio || 0);
  const discount = parseFloat(props.product?.desc_dom || 0);
  return (basePrice + discount).toFixed(2);
});
</script>
